import { Request } from '@/core'
import { reports } from '@/constants/urls'

export default {
  startManagerReport: params =>
    Request.post(reports.startManagerReport, params),
  handleManagerReport: key =>
    Request.get(`${reports.handleManagerReport}?id=${key}`),
}
